module.exports = __webpack_public_path__ + "ha_ico.png?6f9d93ab34d5cf14df27975062e31fc1";